if (!customElements.get('multicolumn-text')) {
    class MulticolumnText extends HTMLElement {
        constructor() {
            super();
            this.mobileLayout = this.dataset.mobileLayout;
            this.swiper = null;

            if (this.mobileLayout === 'slider') {
                this.initSlider();
            }

            // Réinitialiser le slider sur resize
            window.addEventListener('resize', this.handleResize.bind(this));
        }

        handleResize() {
            const isMobile = window.innerWidth <= 768;

            if (this.mobileLayout === 'slider') {
                if (isMobile && !this.swiper) {
                    this.initSlider();
                } else if (!isMobile && this.swiper) {
                    this.destroySlider();
                }
            }
        }

        initSlider() {
            if (window.innerWidth > 768) return;

            const swiperElement = this.querySelector('.swiper');
            if (!swiperElement || this.swiper) return;

            // Charger Swiper si nécessaire
            if (typeof Swiper === 'undefined') {
                const script = document.createElement('script');
                script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
                script.onload = () => this.createSwiper();
                document.head.appendChild(script);

                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
                document.head.appendChild(link);
            } else {
                this.createSwiper();
            }
        }

        createSwiper() {
            const swiperElement = this.querySelector('.swiper');
            if (!swiperElement) return;

            this.swiper = new Swiper(swiperElement, {
                slidesPerView: 1.2,
                spaceBetween: 20,
                centeredSlides: false,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                breakpoints: {
                    480: {
                        slidesPerView: 1.5,
                    },
                    640: {
                        slidesPerView: 2,
                    }
                }
            });
        }

        destroySlider() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }

        disconnectedCallback() {
            this.destroySlider();
            window.removeEventListener('resize', this.handleResize.bind(this));
        }
    }

    customElements.define('multicolumn-text', MulticolumnText);
}